var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from 'moment';
import { map } from 'lodash';
import ModalEditLog from 'app/components/Table/Cells/CellLog/ModalEditLog';
import classes from 'app/components/Table/Cells/CellLog/CellLog.module.scss';
import { Tooltip } from 'app/components/Tooltip/Tooltip.jsx';
import TextRead from 'app/components/TextEditor/TextRead.jsx';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import { getColorFromBackground } from 'app/libs/helpers/getColorFromBackground.js';
import { logLevelsColors, logLevelsLabels, optionsLogLevels } from 'app/core/constants/logLevels';
export function ReadDisplayMin({ message, level, timestamp }) {
    const updateDate = moment(new Date(timestamp)).format('DD/MM/YYYY HH:mm');
    return (_jsx("div", { className: classes.readContainer, style: {
            backgroundColor: logLevelsColors[level],
            color: getColorFromBackground(logLevelsColors[level]),
        }, children: _jsxs("div", { className: "flex row noWrap flex1 marginLeft5 marginRight5 fullHeight alignCenter spaceBetween", children: [_jsx("div", { children: message ? (_jsxs("div", { style: { display: 'flex', alignItems: 'center' }, children: [_jsx(Tooltip, { interactive: true, style: { minWidth: 300, maxHeight: '80vh' }, placement: "left", title: _jsx("div", { className: "flex wrap fullHeight overflowYAuto", style: { maxHeight: 'calc(80vh - 30px)' }, children: _jsx(TextRead, { text: message }) }), children: _jsx("div", { className: classes.isCollapsedTextIcon, children: _jsx(FontIcon, { icon: "fas-pen", style: { color: logLevelsColors[level] } }) }) }), _jsx("div", { style: {
                                    marginLeft: '42px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    fontSize: '12px',
                                    position: 'absolute',
                                }, children: logLevelsLabels[level] })] })) : null }), _jsx("div", { className: classes.date, children: updateDate ? (_jsx(Tooltip, { title: `Last log update: ${updateDate}`, children: _jsxs("span", { children: [_jsx(FontIcon, { icon: "fas-edit", className: "marginRight5 fontSize10", style: { color: getColorFromBackground(logLevelsColors[level]) } }), _jsx("span", { children: updateDate })] }) })) : null })] }) }));
}
export function ReadDisplayAll({ message, level, timestamp, isRowExpanded, minLineHeight, maxLineHeight, }) {
    const updateDate = moment(new Date(timestamp)).format('DD/MM/YYYY HH:mm');
    const color = getColorFromBackground(logLevelsColors[level]);
    return (_jsxs("div", { className: classes.readContainer, style: {
            backgroundColor: logLevelsColors[level],
            color,
            maxHeight: (isRowExpanded ? maxLineHeight : minLineHeight) - 2,
        }, children: [_jsxs("div", { className: classes.top, children: [_jsx("div", { style: {
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            fontSize: '12px',
                        }, children: logLevelsLabels[level] }), _jsx("div", { className: classes.date, children: updateDate ? (_jsx(Tooltip, { title: `Last log update: ${updateDate}`, children: _jsxs("span", { children: [_jsx(FontIcon, { icon: "fas-edit", className: "marginRight5 fontSize10", style: { color } }), _jsx("span", { children: updateDate })] }) })) : null })] }), message && (_jsx("hr", { style: {
                    border: 0,
                    borderTop: `1px solid ${color}`,
                    margin: '20px 10px',
                } })), _jsx(TextRead, { text: message || '', className: classes.comment, containerProps: {
                    style: { maxHeight: `${maxLineHeight - 70}px`, overflowY: 'auto' },
                }, preventImageReflow: true })] }));
}
export const CellLog = (_a) => {
    var { actions } = _a, cellContent = __rest(_a, ["actions"]);
    return Object.assign(Object.assign({}, cellContent), { cellType: 'CellLog', Cell: (instance) => {
            const { cell, prefs } = instance;
            const { minLineHeight, maxLineHeight } = prefs;
            const { getCellProps, value: logValue } = cell;
            const { isRowExpanded } = getCellProps();
            if (!logValue)
                return;
            if (!isRowExpanded && minLineHeight < 49)
                return ReadDisplayMin(logValue);
            return ReadDisplayAll(Object.assign(Object.assign({}, logValue), { isRowExpanded, minLineHeight, maxLineHeight }));
        }, EditModal: (instance) => {
            const { cell, cellPositionLabel } = instance;
            const { value: logValue, getCellProps } = cell;
            const { edition } = getCellProps();
            const { endEdit, save } = edition;
            return (_jsx(ModalEditLog, { onRequestClose: endEdit, onChange: save, logValue: logValue, exponentTitle: cellPositionLabel }));
        }, actions: (instance, cell) => {
            const { getCellProps, column, value: logValue } = cell;
            const { edition } = getCellProps();
            const { save } = edition;
            const resolvedActions = (typeof actions === 'function' ? actions(instance, cell) : actions) || [];
            if (logValue) {
                resolvedActions.push({ separator: true }, {
                    label: 'Severity',
                    editAction: true,
                    items: map(optionsLogLevels, (opt, index) => ({
                        onClick: () => save({
                            level: opt.value,
                            message: logValue.message,
                        }),
                        editAction: true,
                        label: opt.label,
                        color: opt.backgroundColor,
                        hotKeys: [String(index + 1)],
                        rightLabel: String(index + 1),
                    })),
                });
            }
            return resolvedActions;
        }, width: 350 });
};
